import { Grid, Menu, MenuItem, Tooltip, Zoom } from "@material-ui/core";
import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectCurrentUser } from "../../redux/user/user.selector";
import { useStyles } from "./Header.styles";
// import { ReactComponent as NotificationIcon } from "../../assets/img/notification-icon.svg";
// import { ReactComponent as ActiveNotificationIcon } from "../../assets/img/notification-icon-active.svg";
import AvatarDefault from "@material-ui/icons/AccountCircle";
import SemaiLogoText from "../../assets/img/semai-logo.png";
import SemaiProLogo from "../../assets/img/semaiPro_h_white_bg_trans.png";
// import BurgerIcon from "../BurgerIcon/BurgerIcon";
import { logoutStart } from "../../redux/user/user.action";
import AssignmentIcon from "@material-ui/icons/Assignment";

const Header = (props) => {
	const { currentUser, userLogoutStart } = props;
	const classes = useStyles();

	const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);

	const handleClickProfileMenu = (event) => {
		setProfileMenuAnchorEl(event.currentTarget);
	};

	const handleCloseProfileMenu = () => {
		setProfileMenuAnchorEl(null);
	};

	const handleLogout = () => {
		setProfileMenuAnchorEl(null);
		userLogoutStart();
	};

	return (
		<header>
			<Grid
				container
				className={classes.headerContainer}
				justify="space-between"
				alignContent="center"
			>
				<Grid item xs={3}>
					<a href="/activities">
						<img
							src={SemaiProLogo}
							alt="semai"
							className={classes.semaiLogo}
						/>
					</a>
				</Grid>
				<Grid
					item
					xs={7}
					sm={6}
					md={6}
					lg={6}
					container
					justify="flex-end"
					alignItems="center"
				>
					{!!currentUser && (
						<>
							<Grid item>
								<a href="/">
									<Tooltip
										TransitionComponent={Zoom}
										arrow
										title="Activities"
										aria-label="activities"
									>
										<AssignmentIcon
											className={classes.icon}
										/>
									</Tooltip>
								</a>
							</Grid>
							<Grid item>
								<AvatarDefault
									className={classes.icon}
									aria-controls="profile-menu"
									aria-haspopup="true"
									onClick={handleClickProfileMenu}
								/>
								<Menu
									className={classes.menu}
									id="profile-menu"
									anchorEl={profileMenuAnchorEl}
									keepMounted
									open={Boolean(profileMenuAnchorEl)}
									onClose={handleCloseProfileMenu}
								>
									<a href="/profile">
										<MenuItem
											onClick={handleCloseProfileMenu}
										>
											Profile
										</MenuItem>
									</a>
									<MenuItem onClick={handleLogout}>
										Logout
									</MenuItem>
								</Menu>
							</Grid>
						</>
					)}

					{/* <BurgerIcon open={open} handleOpen={setOpen} /> */}
				</Grid>
			</Grid>
		</header>
	);
};

const mapStateToProps = createStructuredSelector({
	currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
	userLogoutStart: () => dispatch(logoutStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
